import type { EmailAction, EmailActionCorrectness } from '../systems/EventBus';
import type { EmailCategory } from './emails';

const RUBRIC: Record<EmailCategory, Partial<Record<EmailAction, EmailActionCorrectness>>> = {
  spam: {
    archive: 'correct',
    reply: 'wrong',
    'forward-collections': 'wrong',
    acknowledge: 'wrong',
  },
  cfo: {
    reply: 'correct',
    acknowledge: 'acceptable',
    archive: 'wrong',
    'forward-collections': 'wrong',
  },
  hr: {
    acknowledge: 'correct',
    archive: 'acceptable',
    reply: 'acceptable',
    'forward-collections': 'wrong',
  },
  'customer-reply': {
    reply: 'correct',
    'forward-collections': 'acceptable',
    archive: 'wrong',
    acknowledge: 'wrong',
  },
  'dispute-followup': {
    reply: 'correct',
    acknowledge: 'acceptable',
    archive: 'wrong',
    'forward-collections': 'wrong',
  },
  internal: {
    acknowledge: 'correct',
    reply: 'acceptable',
    archive: 'acceptable',
    'forward-collections': 'wrong',
  },
  voicemail: {
    reply: 'correct',
    acknowledge: 'acceptable',
    archive: 'wrong',
    'forward-collections': 'wrong',
  },
};

const PRIORITY: Record<EmailActionCorrectness, number> = {
  correct: 0,
  acceptable: 1,
  wrong: 2,
};

export function classifyAction(cat: EmailCategory, act: EmailAction): EmailActionCorrectness {
  return RUBRIC[cat][act] ?? 'wrong';
}

export function actionsForCategory(cat: EmailCategory): EmailAction[] {
  const entries = Object.entries(RUBRIC[cat]) as [EmailAction, EmailActionCorrectness][];
  return entries
    .filter(([, c]) => c !== 'wrong')
    .sort((a, b) => PRIORITY[a[1]] - PRIORITY[b[1]])
    .map(([a]) => a)
    .slice(0, 3);
}

export const ACTION_LABELS: Record<EmailAction, string> = {
  reply: 'Reply',
  archive: 'Archive',
  'forward-collections': 'Forward → Collections',
  acknowledge: 'Got it',
};
